import { render, staticRenderFns } from "./PostCreate.vue?vue&type=template&id=2311f065&scoped=true"
import script from "./PostCreate.vue?vue&type=script&lang=js"
export * from "./PostCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2311f065",
  null
  
)

export default component.exports